import { css } from 'linaria';
import { Variables } from '..';

export const theme = css`
    :global() {
      :root {
        [data-theme='light'] {
          --dropdownOptions-background-color: ${Variables.css.grey7};
          --dropdownOptions-label-separator-color: ${Variables.css.grey4};
          --dropdownOptions-hover-color: ${Variables.css.grey6};
          --dropdownOptions-icon-color: ${Variables.css.catapultBlack};
          --dropdownOptions-group-background-color: ${Variables.css.grey5}
        }

        [data-theme='dark'] {
          --dropdownOptions-background-color: ${Variables.css.grey1};
          --dropdownOptions-label-separator-color: ${Variables.css.grey3};
          --dropdownOptions-hover-color: ${Variables.css.grey5};
          --dropdownOptions-icon-color: ${Variables.css.catapultWhite};
          --dropdownOptions-group-background-color: ${Variables.css.grey2};
        }
      }
`;

export const dropDownContainer = css`
    position: relative;
    background-color: var(--dropdownOptions-background-color);
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 4px;
    box-shadow: ${Variables.css.shadow3};
`;

export const menuItemRoot = css`
    cursor: pointer;
    display: flex;
    padding: 16px 24px 16px 14px;
    align-items: center;
    justify-content: space-between;

    &.selected {
        background-color: ${Variables.css.selectedOverlay};
    }

    &:hover {
        background-color: ${Variables.css.selectedOverlay};
    }
`;

export const disabledMenuItemRoot = css`
    display: flex;
    padding: 16px 14px 16px 14px;
    align-items: center;
    justify-content: space-between;
`;

export const menuItemWrapper = css`
    position: relative;
    display: flex;
    gap: ${Variables.css.spacing8};
    align-items: center;
    width: 100%;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: ${Variables.css.spacing4};
    }

    & svg {
        height: 16px;
        width: 16px;
    }
`;

export const menuItemStyle = css`
    display: flex;
    align-items: center;
`;

export const disabledMenuItemStyle = css`
    display: flex;
    align-items: center;
    opacity: 0.5;
`;

export const menuItemValueStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    color: ${Variables.css.textBody};
`;

export const itemSelected = css`
    margin-left: ${Variables.css.spacing16};
    color: var(--dropdownOptions-icon-color);
`;

export const groupMenuTitle = css`
    width: 100%;
    padding: 8px;
    color: ${Variables.css.textBody};
    border-top: 1px solid var(--dropdownOptions-label-separator-color);
    border-bottom: 1px solid var(--dropdownOptions-label-separator-color);
    font-size: 14px;
    line-height: 20px;
    background: var(--dropdownOptions-group-background-color);
`;

export const clearContainer = css`
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    gap: 8px;
`;

export const searchInputStyle = css`
    display: flex;
    padding: 8px;
`;

export const labelSeparator = css`
    border: 1px solid var(--dropdownOptions-label-separator-color);
    width: 100%;
`;

export const iconStyle = css`
    color: var(--dropdownOptions-icon-color);
    svg path {
        fill: var(--dropdownOptions-icon-color);
    }
`;
